function Separator() {
  return <span>&mdash;</span>;
}

export default Separator;
